// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/js/components/widgets/splashscreen/splashscreen.less
// module id = 1106
// module chunks = 10